export default __webpack_public_path__ + "static/media/health4.00c8381b.png";